module.exports = __webpack_public_path__ + "img/logo3.d31b1a29.png";